import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Reject } from '../Reject';
import Category from 'domain/Category';
import Hazards from 'domain/Hazards';
import { handleApiError } from '../handleApiError';

interface NewSpotState {
  gettingCategories: boolean;
  gettingCategoriesError: boolean;
  gettingCategoriesSuccess: boolean;
  categories: Array<Category>;
  hazards: Array<Hazards>;
}

const initialState: NewSpotState = {
    gettingCategories: false,
    gettingCategoriesError: false,
    gettingCategoriesSuccess: false,
    categories: [],
    hazards: [],
};

export interface GetSpotsResponse {
    categories: Category[];
    hazards: Hazards[];
}

export const getCategories = createAsyncThunk<GetSpotsResponse, void, Reject>(
    'getCategories',
    async (_, thunkAPI) => {
        return axios
            .get<GetSpotsResponse>(`${process.env.REACT_APP_API_URL}/categories`, {
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then((response) => ({ ...response.data }))
            .catch((error) => {
                const apiError = handleApiError(error);
                return thunkAPI.rejectWithValue(apiError);
            });
    }
);

const categoriesSlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCategories.pending, (state) => {
                state.gettingCategories = true;
                state.gettingCategoriesError = false;
                state.gettingCategoriesSuccess = false;
                delete state.categories;
                delete state.hazards;
            })
            .addCase(getCategories.rejected, (state) => {
                state.gettingCategories = false;
                state.gettingCategoriesError = true;
            })
            .addCase(getCategories.fulfilled, (state, action) => {
                state.gettingCategories = false;
                state.gettingCategoriesSuccess = true;
                if (action.payload != null && typeof action.payload === 'object') {
                    Object.assign(state, action.payload);
                }
            });
    },
});

export default categoriesSlice.reducer;
